'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_jquery2.default.ajax({
  url: 'https://reallyfreegeoip.org/json/',
  type: 'POST',
  dataType: 'jsonp',
  success: function success(user_location) {
    console.log(user_location);
    var pathname = window.location.pathname;
    console.log(pathname);
    // var fullpath = 'https://educatedbeards.ca' + pathname;
    //  console.log(fullpath); 

    if (user_location.country_code == 'CA') {
      if (window.top.location.href == 'https://educatedbeards.ca/products') {
        window.top.location.href = 'https://educatedbeards.ca/collections/all';
      } else if (window.top.location.href == 'https://educatedbeards.com/') {
        window.top.location.href = 'https://educatedbeards.ca/';
      } else if (window.top.location.href == 'https://educatedbeards.com' + pathname) {
        if (window.top.location.href == 'https://educatedbeards.ca/products') {
          window.top.location.href = 'https://educatedbeards.ca/collections/all';
        } else {
          window.top.location.href = 'https://educatedbeards.ca' + pathname;
        }
      } else {}
    }
    if (user_location.country_code == 'US' || user_location.country_code != 'CA') {
      if (window.top.location.href == 'https://educatedbeards.com/products') {
        window.top.location.href = 'https://educatedbeards.com/collections/all';
      } else if (window.top.location.href == 'https://educatedbeards.ca/') {
        window.top.location.href = 'https://educatedbeards.com/';
      } else if (window.top.location.href == 'https://educatedbeards.ca' + pathname) {
        if (window.top.location.href == 'https://educatedbeards.com/products') {
          window.top.location.href = 'https://educatedbeards.com/collections/all';
        } else {
          window.top.location.href = 'https://educatedbeards.com' + pathname;
        }
      } else {}
    }
  }

});